import { render, staticRenderFns } from "./WorkCollect.vue?vue&type=template&id=3d0d224d&scoped=true&"
import script from "./WorkCollect.vue?vue&type=script&lang=js&"
export * from "./WorkCollect.vue?vue&type=script&lang=js&"
import style0 from "./WorkCollect.vue?vue&type=style&index=0&id=3d0d224d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d224d",
  null
  
)

export default component.exports